import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaquetesVentaCruzadaComponent } from '../../components/paquetes-venta-cruzada/paquetes-venta-cruzada.component';

@Component({
	standalone: true,
	imports: [
		CommonModule,
		PaquetesVentaCruzadaComponent
	],
	templateUrl: './paquetes-venta-cruzada.view.html',
	styleUrls: ['./paquetes-venta-cruzada.view.scss']
})
export class PaquetesVentaCruzadaView {}
